function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:#4CC2FF;}\r\n\t.st1{fill:#FFFFFF;}\r\n\t.st2{fill:#A80056;}\r\n");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Unknown"
}, /*#__PURE__*/React.createElement("g", {
  id: "computer"
}, /*#__PURE__*/React.createElement("rect", {
  x: 29,
  y: 34.3,
  className: "st0",
  width: 36,
  height: 25.2
}), /*#__PURE__*/React.createElement("rect", {
  x: 43.9,
  y: 57.8,
  className: "st0",
  width: 6.2,
  height: 8
}), /*#__PURE__*/React.createElement("rect", {
  x: 33.6,
  y: 64.4,
  className: "st0",
  width: 26.8,
  height: 3.3
}), /*#__PURE__*/React.createElement("rect", {
  x: 32.4,
  y: 37.6,
  className: "st1",
  width: 29.2,
  height: 18.7
})), /*#__PURE__*/React.createElement("g", {
  id: "questionMark"
}, /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M48.3,51.3h-2.7c0-0.4,0-0.6,0-0.7c0-0.9,0.1-1.6,0.4-2.2c0.3-0.6,0.9-1.2,1.8-1.9c0.9-0.7,1.4-1.2,1.6-1.4 c0.3-0.4,0.4-0.7,0.4-1.2c0-0.6-0.2-1.1-0.7-1.5c-0.5-0.4-1.1-0.6-1.9-0.6c-0.8,0-1.4,0.2-1.9,0.7c-0.5,0.4-0.9,1.1-1.1,2L41.4,44 c0.1-1.3,0.6-2.4,1.6-3.3c1-0.9,2.3-1.3,4-1.3c1.7,0,3.1,0.5,4.1,1.4c1,0.9,1.5,2,1.5,3.2c0,0.7-0.2,1.3-0.6,1.9 c-0.4,0.6-1.2,1.4-2.4,2.4c-0.6,0.5-1,1-1.2,1.3C48.4,49.8,48.3,50.4,48.3,51.3z M45.6,55.3v-3h3v3H45.6z"
})));

var SvgDeliveryUnknown = function SvgDeliveryUnknown(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "29 34.3 36 33.3",
    xmlSpace: "preserve",
    width: 36,
    height: 33.3,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDeliveryUnknown, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/delivery-UNKNOWN.c3f21ab5.svg";
export { ForwardRef as ReactComponent };